import axios from "axios"

export default axios.create(
    {
        baseURL:"https://blog-7f7c.onrender.com/"
    }
)